module.exports = __webpack_public_path__ + "static/media/Flow-calendar-selected.8bc90517.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/Flow-calendar-selected.svg
// module id = 4075
// module chunks = 0